export default "__VITE_ASSET__BX1akoDM__"